import React, {Component} from 'react';
import { Modal, Icon, message } from 'antd';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

class SortInnerComponent extends Component {
    state = {
        isShow: true
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        const { item } = this.props;
        const child = item['children'];
        this.props.sortChildItem(arrayMove(child, oldIndex, newIndex), this.props.curIndex);
    };

    render () {
        const { isShow } = this.state;
        const { item } = this.props;
        const child = item['children'];
        const display = item['display'];
        const hasChild = child ? child.length > 0 : false;
        return (
            <div className='sort-contain' style={{width: '90%', marginLeft: 8}}>
                <div className="sort-header" style={{position: "relative", borderRadius: 5, background: '#3cd0cfc9', fontWeight: 500}}>
                    {item.responsibility}
                    {
                        hasChild && !!display &&
                        <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                {
                    isShow && !!display &&
                    <div className="sort-content">
                        <SortableHorList child={child} axis="xy" hideSortableGhost={false} lockToContainerEdges={true} onSortEnd={this.onSortEnd} />
                    </div>
                }
            </div>
        )
    }
}

const SortInnerWrap = SortableElement(({item, curIndex, sortChildItem}) => {
    return (
        <SortInnerComponent sortChildItem={sortChildItem} key={`item-${item.id}`} curIndex={curIndex} item={item} />
    )
});

const SortInnerList = SortableContainer(({items = [], sortChildItem}) => {
    items = items || [];
    return (
        <div>
            {
                items.map((item, index) => (
                    <SortInnerWrap sortChildItem={sortChildItem} key={`item-${index}`} index={index} item={item} curIndex={index}/>
                ))
            }
        </div>
    );
});

const sortItemStyle = {
    width: '47%',
    minHeight: 30,
    margin: 5,
    padding: '0 5px',
    lineHeight: '18px',
    color: '#333',
    background:'#eee',
    fontSize: 14,
    fontWeight: 500,
    border: '1px solid #eee',
    borderRadius: 5,
    whiteSpace: 'break-spaces',
    cursor: 'move',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

const SortableHorItem = SortableElement(({title}) =>
    <div style={sortItemStyle}>{title}</div>
);

const SortableHorList = SortableContainer(({child = []}) => {
    return (
        <div className="sort-wrap" style={{ justifyContent: 'space-between'}}>
            {
                (child || []).map((value, index) => {
                    if (value.centralStartupSupport) {
                        return (
                            <SortableHorItem key={value.id} index={index} title={value.centralStartupSupport} hideSortableGhost={false}/>
                        )
                    }
                    if (value.responsibility) {
                        return (
                            <SortableHorItem key={value.id} index={index} title={value.responsibility} hideSortableGhost={false}/>
                        )
                    }
                })
            }
        </div>
    );
});


class SortComponent extends Component {
    state = {
        isShow: true,
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        const { item } = this.props;
        const child = item['children'];
        this.props.getChildItem(arrayMove(child, oldIndex, newIndex), this.props.curIndex);
    };

    sortEnd = ({oldIndex, newIndex}) => {
        const { item } = this.props;
        const child = item['children'];
        this.props.getChildItem(arrayMove(child, oldIndex, newIndex), this.props.curIndex);
    };

    sortChildItem = (i, index) => {
        const { item } = this.props;
        const child = item['children'];
        child[index]['children'] = i;
        this.props.getChildItem(arrayMove(child), this.props.curIndex);
    }

    render () {
        const { item } = this.props;
        const { isShow } = this.state;
        const child = item['children'];
        const display = item['display'];

        let flag = false;
        (child || []).map(item => {
            if (item.children && !!item.display) {
                flag = true;
            }
        });

        const hasChild = child ? child.length > 0 : false;
        return (
            <div className='sort-contain'>
                <div className="sort-header" style={{ position: 'relative' }}>
                    {item.responsibility}
                    {
                        hasChild && !!display &&
                        <div
                            className="sort-template-traggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ isShow: !isShow })
                            }}
                        >
                            <Icon type={isShow ? "up" : "down"} style={{fontSize: "12px", position: "relative", top: "1px"}}/>
                        </div>
                    }
                </div>
                <div className="sort-content">
                    {
                        isShow && !!display && (
                            !flag
                            ?
                                <SortableHorList child={child} axis="xy" hideSortableGhost={false} lockToContainerEdges={true} onSortEnd={this.onSortEnd} />
                            :
                                <SortInnerList
                                    sortChildItem={this.sortChildItem}
                                    items={child}
                                    axis="y"
                                    lockAxis="y"
                                    hideSortableGhost={false}
                                    helperClass="sortHelper"
                                    onSortEnd={this.sortEnd}
                                />
                        )
                    }
                </div>
            </div>
        )
    }
}

const SortableWrap = SortableElement(({item, curIndex, getChildItem}) => {
    return (
        <SortComponent getChildItem={getChildItem} key={`item-${item.id}`} curIndex={curIndex} item={item} />
    )
});

const SortableList = SortableContainer(({items = [], getChildItem}) => {
    items = items || [];
    return (
        <div>
            {
                items.map((item, index) => (
                    <SortableWrap  getChildItem={getChildItem} key={`item-${index}`} index={index} item={item} curIndex={index}/>
                ))
            }
        </div>
    );
});

class SortList extends Component {
    state = {
        visible: false,
        loading: false,
        items: [],
    }

    show = (data) => {
        this.setState({
            visible: true,
            items: data
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = () => {
        const { items } = this.state;
        this.props.confirm(items, true);
        this.hide()
    };

    onSortEnd = ({oldIndex, newIndex}) => {
        const { items } = this.state;
        this.setState({ items: arrayMove(items, oldIndex, newIndex) });
    };

    getChildItem = (item, index) =>{
        const { items } = this.state;
        items[index]['children'] = item;
        this.setState({ items });
    }
    
    render() {
        const { visible, loading, items } = this.state;
        return (
            <Modal
                title="排序调整"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="create-modal sort-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
            >
                <SortableList
                    getChildItem={this.getChildItem}
                    items={items}
                    axis="y"
                    lockAxis="y"
                    hideSortableGhost={false}
                    helperClass="sortHelper"
                    onSortEnd={this.onSortEnd}
                />
            </Modal>
        );
    }
}

export default SortList;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/CrcServiceContent/SortList.js